export interface MarginListPage<T> {
  results?: T[] | null;
  next?: string | null;
  count?: number | null;
}

export interface CollectedMarginPage<T> {
  rows: T[];
  count: number;
  next: string | null;
}

/**
 * Fold one page into the rows already collected.
 * A null next stops. count stays the full total from the response.
 * A next link is ignored once the collected rows reach that total.
 */
export function collectMarginListPage<T>(
  collected: T[],
  page: MarginListPage<T> | null | undefined,
): CollectedMarginPage<T> {
  const rows = collected.concat((page && page.results) || []);
  const reportedCount = page && typeof page.count === 'number' && !Number.isNaN(page.count)
    ? page.count
    : rows.length;
  const nextLink = page && page.next ? String(page.next) : null;
  const reachedTotal = rows.length >= reportedCount;
  return {
    rows,
    count: reportedCount,
    next: nextLink && !reachedTotal ? nextLink : null,
  };
}
